import { useEffect, useMemo, useState } from "react";
import { Dropdown, Form, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import axios from "axios";
import { addStepToSequence } from "../../services/CollectionsSvc";
import { API_URL } from "../../constants/Globals";
import useDebounce from "../../hooks/useDebounce";

const AddStepToCollectionModal = ({
  isVisible = false,
  onClose,
  selNetworkId,
  sequenceId,
  orderNumber,
  hideCloseButton,
}) => {
  const [formData, setFormData] = useState({
    searchInput: "",
    partType: "",
  });

  const [pollList, setPollList] = useState([]);
  const [formList, setFormList] = useState([]);

  const handleOnChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const searchPolls = () => {
    axios
      .get(
        API_URL +
          `/admin/debate/getDebates?isActive=1&perPage=5&pageNumber=1&clientId=${selNetworkId}&searchText=${debouncedSearch.trim()}&isQuiz=${formData.partType === "quiz" ? 1 : 0}`
      )
      .then(({ data }) => setPollList(data.data.rows));
  };

  const fetchForms = () => {
    axios.get(API_URL + `/forms?clientId=${selNetworkId}`).then(({ data }) => {
      setFormList(data.data);
    });
  };

  useEffect(() => {
    fetchForms();
  }, []);

  const debouncedSearch = useDebounce(formData.searchInput, 1000);

  useEffect(() => {
    if (debouncedSearch && formData.partType !== "form") searchPolls();
  }, [debouncedSearch, formData.partType]);

  const handleDropdownSelect = async (selectedPoll) => {
    try {
      const data = {
        sequenceId: parseInt(sequenceId),
        order: orderNumber + 1,
        isBranch: false,
        partType: formData.partType,
        partId: selectedPoll.id,
        content: selectedPoll.thesis,
      };
      const response = await addStepToSequence(data);
      if (response.data.status === 1) {
        onClose(true);
      }
    } catch (error) {}
  };
  const searchedFormList = useMemo(() => {
    if (!formList || !formData.searchInput) return formList || [];
    return formList.filter((form) =>
      form.name.toLowerCase().includes(formData.searchInput.toLowerCase())
    );
  }, [formData.searchInput, formList]);

  return (
    <Modal
      onHide={onClose}
      className="removeDebModal"
      size="md"
      //   backdrop={false}
      show={isVisible}
    >
      <Modal.Header closeButton={hideCloseButton}>
        <Modal.Title>Add Step to Sequence</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ margin: "0px" }}>
        <div className="modalContentWrapper">
          <Form className="toggleArchive common-form">
            <Form.Select
              className="common-input"
              value={formData.partType}
              name="partType"
              onChange={handleOnChange}
            >
              <option value="">Select</option>
              <option value="quiz">Quiz</option>
              <option value="poll">Poll</option>
              <option value="form">Form</option>
            </Form.Select>
            <Form.Control
              value={formData.searchInput}
              name="searchInput"
              style={{ marginTop: "10px" }}
              placeholder="Search Poll"
              onChange={handleOnChange}
              className="common-input"
              autoComplete="off"
            />
            {formData.searchInput && (
              <Dropdown.Menu show style={{ width: "94%", overflow: "hidden" }}>
                {formData.partType === "form" ? (
                  <>
                    {searchedFormList.length > 0 ? (
                      searchedFormList.map((option, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => handleDropdownSelect(option)}
                        >
                          {option.name}
                        </Dropdown.Item>
                      ))
                    ) : (
                      <Dropdown.Item disabled>No options found</Dropdown.Item>
                    )}
                  </>
                ) : (
                  <>
                    {pollList.length > 0 ? (
                      pollList.map((option, index) => (
                        <Dropdown.Item
                          key={index}
                          onClick={() => handleDropdownSelect(option)}
                        >
                          {option.thesis}
                        </Dropdown.Item>
                      ))
                    ) : (
                      <Dropdown.Item disabled>No options found</Dropdown.Item>
                    )}
                  </>
                )}
              </Dropdown.Menu>
            )}
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps)(AddStepToCollectionModal);
